import React from 'react';
import classNames from 'classnames';
import Icon, { IconName } from 'app/common/components/controls/icon';
import styles from './UpgradePromptButton.less';

/**
 * UpgradePromptButton props
 *
 * cta: call to action of prompt, navigates user within the page
 * ctaLink: link for call to action
 * ctaTrackEvent: function expected to fire a trackUe event, fired on click of cta
 * iconName: name of icon
 * isDarkTheme: controls dark theme
 */

interface UpgradePromptButtonProps {
  cta: string;
  ctaLink: string;
  ctaTrackEvent?: () => void;
  iconName: IconName;
  isDarkTheme?: boolean;
}

export const UpgradePromptButton = (props: UpgradePromptButtonProps) => {
  const { cta, ctaLink, ctaTrackEvent, iconName, isDarkTheme } = props;

  const onClickCTA = (eventContext: object) => {
    if (ctaTrackEvent) {
      ctaTrackEvent();
    }
  };

  const promptClasses = classNames(
    'upgrade-prompt-button',
    styles.upgradePromptButton,
    (isDarkTheme && styles.upgradePromptButtonDarkTheme) ||
      styles.upgradePromptButtonLightTheme,
    isDarkTheme && 'upgrade-prompt-button-dark',
  );

  return (
    <a href={ctaLink} className={promptClasses} onClick={onClickCTA}>
      <div className={styles.upgradePromptButtonIconBackground}>
        <Icon
          className={styles.upgradePromptButtonIcon}
          name={iconName}
          small={true}
        />
      </div>
      <div className={styles.upgradePromptButtonCTA}>{cta}</div>
    </a>
  );
};
